import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { TributacaoRecolhimento } from "../api/dto/tributacao-recolhimento";

@Injectable({
    providedIn: 'root',
})
export class TributacaoRecolhimentoService{

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'tributacao-recolhimento';

    listarTodos(): Observable<TributacaoRecolhimento[]> {
        return this.http.get<TributacaoRecolhimento[]>(this.url);
    }

    listarPorOpcaoTributo(opcao?: string): Observable<TributacaoRecolhimento[]> {
        return this.http.get<TributacaoRecolhimento[]>(`${this.url}/opcao/${opcao}`);
    }
}